import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SentryService } from './sentry.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InstagramService {

  constructor(private http: HttpClient, private sentryService: SentryService) {
  }
  public getDataFromInstagram(access_token: object): Observable<object | {}> {
    return this.http.get(`${environment.instagramOAuth2Url}/${access_token['user_id']}/media?access_token=${access_token['access_token']}&fields=id,username,like_count,comments_count,caption,media_type,media_url,account_type`, { headers: { Anonymous: 'Anonymous' } }).pipe(
      catchError(err => { return this.handleError(err) })
    );
  }
  public refreshInstagramToken(access_token: object): Observable<object | {}> {
    return this.http.get(`${environment.instagramOAuth2Url}/refresh_access_token?access_token=${access_token}&&grant_type=ig_refresh_token`, { headers: { Anonymous: 'Anonymous' } }).pipe(
      catchError(err => { return this.handleError(err) })
    );
  }
  private handleError(error) {
    this.sentryService.errorHandling(error, 'Instagram-service', error.error.message ? error.error.message : (error.message ? error.message : error));
    return throwError(error);
  }
}
